import React from 'react'
import Sidebar from '../../components/SideBar'
import EventCardGrid from './components/Cointainer'

function Eventmanagement() {
  return (
    <div className='flex bg-white'>
        <div className='bg-[#272938]'><Sidebar/></div>
        <div className='w-full'><EventCardGrid/></div>
    </div>
  )
}

export default Eventmanagement
